/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Multica_PricingInputs */

const en_mk_cmp_multica_pricing = /** @type {(inputs: Mk_Cmp_Multica_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not published. Their /pricing and /docs/billing pages returned 404 when we checked; all that is certain is that self-hosting is free and a paid cloud tier exists on a prepaid-seat model.`)
};

const id_mk_cmp_multica_pricing = /** @type {(inputs: Mk_Cmp_Multica_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak dipublikasikan. Halaman /pricing dan /docs/billing mengembalikan 404 saat kami periksa; yang bisa dipastikan hanya bahwa self-host gratis dan ada tier cloud berbayar dengan model kursi prabayar.`)
};

/**
* | output |
* | --- |
* | "Not published. Their /pricing and /docs/billing pages returned 404 when we checked; all that is certain is that self-hosting is free and a paid cloud tier ex..." |
*
* @param {Mk_Cmp_Multica_PricingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_multica_pricing = /** @type {((inputs?: Mk_Cmp_Multica_PricingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Multica_PricingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_multica_pricing(inputs)
	return en_mk_cmp_multica_pricing(inputs)
});